<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="printTests"
    >
      <section slot="pdf-content" class="p-2 font-modify">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p style="display: inline-block; margin-left: 70px">: دائرة الصحة</p>
          <p style="display: inline-block">وزارة الصحة</p>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p style="display: inline-block; margin-left: 70px">: مستشفى</p>
          <p style="display: inline-block">
            دائرة الامور الفنية/ قسم خدمات نقل الدم
          </p>
        </div>

        <p style="text-align: center; font-weight: bold">Transfusion note</p>

        <div>
          <table class="styled-table">
            <!-- <thead>
              <tr>
                <th>Test Name</th>
                <th>Result</th>
                <th>Reference Range</th>
                <th>Result - Normal</th>
              </tr>
            </thead> -->
            <tbody style="font-size: 10px; font-weight: bold">
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Patient name اسم المريض
                </td>
                <td colspan="1">{{ getNestedProperty(newData, 'patient_card.patient.name') }}</td>
                <td colspan="2" style="text-align: left">Age العمر</td>
                <td colspan="1">{{ patientAge }}</td>
                <td rowspan="2" style="text-align: left">Sex الجنس</td>
                <td colspan="2" style="text-align: left">Male ذكر</td>
                <td colspan="1">
                  {{
                    getNestedProperty(newData, 'patient_card.patient.gender') == "Male" ? "ذكر" : ""
                  }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Patient ID عنوان المريض
                </td>
                <td colspan="1"></td>
                <td colspan="2" style="text-align: left">Date التاريخ</td>
                <td colspan="1">
                  {{ getNestedProperty(newData, 'patient_card.patient.birth_date') }}
                </td>
                <td colspan="2" style="text-align: left">Female أنثى</td>
                <td colspan="1">
                  {{
                    getNestedProperty(newData, 'patient_card.patient.gender') == "Female"
                      ? "أنثى"
                      : ""
                  }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Diagnosis</td>
                <td colspan="4">{{ getNestedProperty(newData, 'patient_card.diagnosis') }}</td>
                <td colspan="1" style="text-align: left">Ward الردهة</td>
                <td colspan="3"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Bed number رقم السرير
                </td>
                <td colspan="8"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Patient blood group فصيلة دم المريض
                </td>
                <td colspan="1">
                  {{ getNestedProperty(newData, 'blood_bottle.abo') }}/{{ getNestedProperty(newData, 'blood_bottle.rh') }}
                </td>
                <td colspan="2" style="text-align: left">
                  Pre-transfusion Hb الهيموكلوبين قبل اعطاء الدم
                </td>
                <td colspan="1">{{ newData.pre_transfusion_hb }} g/dl</td>
                <td colspan="1" style="text-align: left">date</td>
                <td colspan="3"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Of blood مصدر</td>
                <td colspan="1">{{ newData.source_of_blood }}</td>
                <td colspan="2" style="text-align: left">Bag number رقم الكيس</td>
                <td colspan="5">
                  {{ getNestedProperty(newData, 'blood_bottle.bottle_identifier') }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Collection date تاريخ انتاج الدم</td>
                <td colspan="1">
                  {{ getNestedProperty(newData, 'blood_bottle.production_date') }}
                </td>
                <td colspan="2" style="text-align: left">
                  Type of component الوع منتج الدم
                </td>
                <td colspan="5"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Amount of blood الكمية
                </td>
                <td colspan="1"></td>
                <td colspan="2" style="text-align: left">Cross match فعص</td>
                <td colspan="5"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="font-size: 10px; font-weight: bold">
          <table
            class="styled-table"
            style="font-size: 10px; font-weight: bold"
          >
            <!-- <thead>
              <tr>
                <th>Test Name</th>
                <th>Result</th>
                <th>Reference Range</th>
                <th>Result - Normal</th>
              </tr>
            </thead> -->
            <tbody>
              <tr style="text-align: center">
                <td colspan="10" style="text-align: left">
                  Transfusion start time :
                  {{ newData.transfusion_start_time }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="font-weight: bolder !important">
                  Parameter
                </td>
                <td colspan="1" style="font-weight: bolder !important">
                  Pre-transfusion
                </td>
                <td colspan="1" style="font-weight: bolder !important">
                  15 min
                </td>
                <td colspan="1" style="font-weight: bolder !important">
                  30 min
                </td>
                <td colspan="1" style="font-weight: bolder !important">
                  1 hour
                </td>
                <td colspan="1" style="font-weight: bolder !important">
                  2 hour
                </td>
                <td colspan="1" style="font-weight: bolder !important">
                  3 hour
                </td>
                <td colspan="1" style="font-weight: bolder !important">
                  4 hour
                </td>
                <td colspan="1"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Pulse</td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.pulse.minutes_after_transfusion_1"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.pulse.minutes_after_transfusion_15"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.pulse.minutes_after_transfusion_30"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.pulse.minutes_after_transfusion_60"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.pulse.minutes_after_transfusion_120"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.pulse.minutes_after_transfusion_180"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.pulse.minutes_after_transfusion_240"
                    )
                  }}
                </td>
                <td colspan="1"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">BP</td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Temperature</td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.temperature.minutes_after_transfusion_1"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.temperature.minutes_after_transfusion_15"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.temperature.minutes_after_transfusion_30"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.temperature.minutes_after_transfusion_60"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.temperature.minutes_after_transfusion_120"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.temperature.minutes_after_transfusion_180"
                    )
                  }}
                </td>
                <td colspan="1">
                  {{
                    getNestedProperty(
                      newData,
                      "vital_signs.temperature.minutes_after_transfusion_240"
                    )
                  }}
                </td>
                <td colspan="1"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Respiration</td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Color of urine</td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
                <td colspan="1"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Time transfusion completed
                </td>
                <td colspan="10">
                  {{ newData.time_transfusion_completed }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Completion of transfusion note (check the answer:
                </td>
                <td colspan="10" style="text-align: left">
                  <tr style="width: 100%; height: 15px">
                    {{
                      newData.completion_of_transfusion_note
                    }}
                  </tr>
                  <tr style="width: 100%">
                    Transfusion was detected due to adverse reaction of severe
                    category
                  </tr>
                  <tr style="width: 100%">
                    Completed with management of febrile/allergic reaction
                  </tr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p style="text-align: center; font-weight: bold">
          Adverse transfusion reaction
        </p>

        <div>
          <table class="styled-table">
            <!-- <thead>
        <tr>
          <th>Test Name</th>
          <th>Result</th>
          <th>Reference Range</th>
          <th>Result - Normal</th>
        </tr>
      </thead> -->
            <tbody style="font-size: 10px; font-weight: bold">
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Duration after sarting transfusion
                </td>
                <td colspan="13" style="text-align: left">
                  Minutes: <span style="margin-right: 50px;">{{
                    getNestedProperty(newData.blood_transfusion_reaction[0], 'minutes_duration_unitl_adverse_reaction')
                  }}</span>
                Hours: 
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Type of reaction (sign & sympt:
                  {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'type_of_reaction') }}
                </td>
                <td colspan="13" style="text-align: left; vertical-align: top">
                  Management of treatment:
                  {{
                    getNestedProperty(newData.blood_transfusion_reaction[0], 'management_of_treatment')
                  }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Allergic reaction itching erythema
                </td>
                <td
                  colspan="13"
                  rowspan="10"
                  style="text-align: left; vertical-align: top"
                >
                  <p style="margin: 0">1-Stop of transfusion</p>
                  <p style="margin: 0">2-</p>
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Riger:
                  {{
                    getNestedProperty(newData.blood_transfusion_reaction[0], 'rigor_reaction') === 1
                      ? "Yes"
                      : "No"
                  }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Fever:{{
                    getNestedProperty(newData.blood_transfusion_reaction[0], 'fever_temperature')
                  }}C
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Вp.............../ mm Hg
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Tachycardia
                  {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'tachycardia') }}
                  beat/mm
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Dyspuea
                  {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'dyspuea') }} breath/min
                </td>
              </tr>
              <!-- <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Dyspuea............breath/min
                </td>
              </tr> -->
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Nausea or vomiting :
                  {{
                    getNestedProperty(newData.blood_transfusion_reaction[0], 'vomiting') === 1
                      ? "Yes"
                      : "No"
                  }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Pain at : {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'pain_at') }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Urine output (decrease) :
                  {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'urine_output_decrease') }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Urine color
                  {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'urine_color') }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Others: {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'others') }}
                </td>
                <td colspan="7" style="text-align: left">
                  Chief complaint / concern
                </td>
                <td colspan="6" style="text-align: left"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">Outcome: improved</td>
                <td colspan="3" style="text-align: left; width: 30px"></td>
                <td colspan="3" style="text-align: left">
                  Referred for further management
                </td>
                <td colspan="3" style="text-align: left; width: 30px"></td>
                <td colspan="3" style="text-align: left">death</td>
                <td colspan="3" style="text-align: left; width: 70px"></td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Cause of reaction:
                </td>
                <td colspan="13" style="text-align: left">
                  {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'cause_of_reaction') }}
                </td>
              </tr>
              <tr style="text-align: center">
                <td colspan="2" style="text-align: left">
                  Treatment:
                </td>
                <td colspan="13" style="text-align: left">
                  {{ getNestedProperty(newData.blood_transfusion_reaction[0], 'treatment') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="font-size: 8px; font-weight: bold">
          <p
            style="
              text-align: right;
              font-weight: bold;
              text-decoration: underline;
            "
          >
            ملاحظات
          </p>
          <p style="text-align: right; font-weight: bold; margin: 0">
            ١-ختم عملية نقل الدم باشراف الطبيب
          </p>
          <p style="text-align: right; font-weight: bold; margin: 0">
            ٢-تتم تهيئة كافة متطلبات عملية نقل الدم قبل استلام ملتج الدم من مصرف
            الدم الفرعي للمستشفى
          </p>
          <p style="text-align: right; font-weight: bold; margin: 0">
            ٣-يتم التاكد من الفح،صات الفيد،سية للمريض قبل بدا عملية نقل الدم
          </p>
          <p style="text-align: right; font-weight: bold; margin: 0">
            ٤-نهاد قنينة الدم الى المصرف الفرعي فورا و خلال ٣٠ دقيقة من وقت
            استلام في حالة تاجيل عملية نقل الدم و لاي سبب كان
          </p>
          <p style="text-align: right; font-weight: bold; margin: 0">
            ٥-نكلى الاستمارة بنسختين او تستنسخ ، تحف/ في طبلى المريض ، تسلم
            النسخه الاخرى الى مصرف الدم الفرعي للمستشفى
          </p>
          <p style="text-align: right; font-weight: bold; margin: 0">
            ٦-نرسل الاستمارات التي تحمل مضاعفات نقل الدم بموقف شهري الى شعبة
            خدمات نقل الدم في دائرة الصحة المعنية
          </p>
          <p style="text-align: right; font-weight: bold; margin: 0">
            ٧-تعتمد نسخة مصرف الدم الفرعي كمعطى فعلي لاكياس الدم المجهزة للمرضى
            في الردهات و صالات العمليات و وحدات الطوارى
          </p>

          <hr />
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <p style="display: inline-block; margin: 0">
              Name and signature of doctor
            </p>
            <p style="display: inline-block; margin-left: 70px; margin: 0">
              Name and signature of nurse
            </p>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    VueHtml2pdf,
  },

  data() {
    return {
      newData: {},
    };
  },
  props: ["data"],
  // mounted() {
  //   this.newData();
  // },
  watch: {
    data(newVal) {
      this.newData = newVal;
      console.log("this.newData", this.newData);
    },
  },
  computed: {
    patientAge() {
      if (!this.getNestedProperty(this.data, 'patient_card.patient.birth_date')) return null;
      const birthDate = new Date(this.getNestedProperty(this.data, 'patient_card.patient.birth_date'));
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
  },

  methods: {
    generateReport() {
      this.$refs.printTests.generatePdf();
    },
    getNestedProperty(obj, path, defaultValue = "") {
      const result = path.split(".").reduce((acc, part) => {
        if (Array.isArray(acc) && acc.length > 0 && part === '0') {
          return acc[0];
        }
        return acc && acc[part] ? acc[part] : defaultValue;
      }, obj);
      console.log("result", result);
      return result;
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}/${month}/${day}`;
    },
  },
};
</script>

<style scoped>
td {
  padding: 1px !important;
}
.arabic-text {
  direction: rtl;
  unicode-bidi: bidi-override;
  font-family: "Scheherazade", Arial, sans-serif; /* Use a font that supports Arabic */
  direction: rtl; /* Set right-to-left direction */
}
.font-modify {
  letter-spacing: normal !important;
}
/* General Styling for PDF */
.pdf-content {
  font-family: Arial, sans-serif;
}
.header {
  text-align: center;
  margin-bottom: 20px;
}
.header-title {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 5px;
}
.subheader-title {
  font-size: 24px;
  font-weight: 600;
}
.info-header {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  margin-bottom: 20px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  margin-bottom: 20px;
}
.styled-table th,
.styled-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}
.styled-table th {
  background-color: #f3f3f3;
  font-weight: bold;
}
.footer-info {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.location-info {
  display: flex;
  gap: 8px;
}
</style>
